import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Combines clsx and tailwind-merge for optimal class name handling.
 * Use this for conditional class names that may have Tailwind conflicts.
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Format date in newspaper style: "January 5, 2026"
 */
export function formatNewspaperDate(date = new Date()) {
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

/**
 * Generate volume and issue numbers based on date
 * (decorative - starts from arbitrary base)
 */
export function getVolumeIssue(date = new Date()) {
  const baseYear = 2024;
  const year = date.getFullYear();
  const volume = year - baseYear + 1;
  const startOfYear = new Date(year, 0, 1);
  const weekNumber = Math.ceil(
    ((date.getTime() - startOfYear.getTime()) / 86400000 + 1) / 7
  );

  return {
    volume: toRoman(volume),
    issue: String(weekNumber).padStart(2, "0"),
  };
}

/**
 * Convert number to Roman numerals (for volume numbers)
 */
function toRoman(num) {
  const romanNumerals = [
    [10, "X"],
    [9, "IX"],
    [5, "V"],
    [4, "IV"],
    [1, "I"],
  ];

  let result = "";
  for (const [value, numeral] of romanNumerals) {
    while (num >= value) {
      result += numeral;
      num -= value;
    }
  }
  return result;
}
